export const offerApproveConstants = {
    APPROVE_OFFER_PENDING:   'APPROVE_OFFER_PENDING',
    APPROVE_OFFER_FULFILLED:   'APPROVE_OFFER_FULFILLED',
    APPROVE_OFFER_REJECTED:   'APPROVE_OFFER_REJECTED',
};
